// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#PrintFrame {\n    position: absolute;\n    box-shadow: rgba(0, 0, 0, 0.5) 0 0 0 30000px;\n    z-index: 1;\n    pointer-events: none;\n    text-align: center;\n    font-size: small;\n    overflow: hidden;\n}\n\n#PrintFrame span.size-box {\n    background: rgba(255, 255, 255, 0.5);\n    padding: 0.25em;\n    white-space: nowrap;\n}\n\n#PrintFrameEventLayer {\n    z-index: 2;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
